import { delayAsync } from "@eusoft/webapp-core/utils/Async";
import { executeAsync } from "./DataService";
import { showWaitForCardAsync } from "../pages/paymentCard/WaitForCard";
import type { IPaymentCard, IPaymentService, IPrinter, IReadCard, IWriteCard, KeyType } from "../abstraction/IPaymentService";
import type { IPrintCommand } from "../entities/Commands";

export class MockPayment implements IPaymentService {

    async readCardAsync(options: IReadCard) {

        await showWaitForCardAsync({
            message: options.message,
            amount: options.amount
        }, () => delayAsync(100000));

        const card = {
            code: "539779AD710001",            
        } as IPaymentCard;

        if (options.payToken) {
            card.payAuth = await executeAsync("EncodeCardCode", {
                cardCode: card.code,
                paymentToken: options.payToken
            });
        }

        return card;
    }


    listPrinters(): IPrinter[] {
        return [{
            name: "Fake Printer",
            model: "Fake Printer"
        }];
    }

    print(printerModel: string, commandList: IPrintCommand[]) {

    }

    signPayloadPos(payload: string) {
        return atob("FAKE");
    }

    getFingerprint(type: KeyType) {

        return "fake";
    }

    async signPayloadAuthAsync(payload: string) {
        return atob("FAKE");
    }


    async writeCardAsync(options: IWriteCard) {
        return true;
    }


}
